export const STATUS_OPTIONS = [
    { value: 'active', label: 'Ativo' },
    { value: 'inactive', label: 'Inativo' },
];

export const YES_NO_OPTIONS = [
    { value: 'yes', label: 'Sim' },
    { value: 'no', label: 'Não' },
];

export const ORIGIN_OPTIONS = [
    { value: 'internal', label: 'Interna' },
    { value: 'external', label: 'Externa' },
];

export const MODULES = [
    { key: 'Supplies', label: 'Insumos' },
    { key: 'Resources', label: 'Recursos' },
    { key: 'Products', label: 'Produtos' },
    { key: 'Orders', label: 'Ordens' },
    { key: 'Reports', label: 'Relatórios' },
    { key: 'Warehouses', label: 'Depósitos' },
    { key: 'MovementTypes', label: 'Tipos de movimento' },
    { key: 'Tenant', label: 'Empresa' },
    { key: 'User', label: 'Usuários' },
    { key: 'Roles', label: 'Perfis' },
    { key: 'Clients', label: 'Clientes' },
    { key: 'Sales', label: 'Pedidos' },
];

export const MODULE_OPTIONS = [...MODULES]
    .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'))
    .map((m) => ({ value: m.key, label: m.label }));
